import { CustomFormsListPage } from './views/formsListPage/customFormsListPage';

export const SettingsCustomFormsView = (): JSX.Element => {
  return <CustomFormsListPage />;
};
